var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0122 18H7.51221M36.7622 4.5V11.25M18.7622 4.5V11.25M27.7622 40.5V27M21.0122 33.75H34.5122M18.3122 49.5H37.2122C40.9926 49.5 42.8827 49.5 44.3266 48.7643C45.5967 48.1171 46.6294 47.0845 47.2765 45.8144C48.0122 44.3705 48.0122 42.4804 48.0122 38.7V19.8C48.0122 16.0196 48.0122 14.1295 47.2765 12.6856C46.6294 11.4155 45.5967 10.3829 44.3266 9.73571C42.8827 9 40.9926 9 37.2122 9H18.3122C14.5319 9 12.6417 9 11.1978 9.73571C9.92768 10.3829 8.89506 11.4155 8.24791 12.6856C7.51221 14.1295 7.51221 16.0196 7.51221 19.8V38.7C7.51221 42.4804 7.51221 44.3705 8.24791 45.8144C8.89506 47.0845 9.92768 48.1171 11.1978 48.7643C12.6417 49.5 14.5319 49.5 18.3122 49.5Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth03);
export default __webpack_public_path__ + "static/media/health03.7ab03b150efc716da67dbd19e814e315.svg";
export { ForwardRef as ReactComponent };